import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import {
  closeModal,
  cloneEmail,
  emailTemplatesList,
  gotoUrl,
  campaignsList,
} from "../../actions";
import styles from "../../components/Modal.module.css";

const identity = (data) => data;

export class CloneEmailModal extends Component {
  constructor(props) {
    super(props);
    this.clone = this.clone.bind(this);
    this.nameRef = createRef();
    this.campaignIdRef = createRef();
  }

  componentDidMount() {
    if (this.nameRef?.current) {
      this.nameRef.current.focus();
    }
    this.props.campaignsList(this.props.accountId, {}, false, true);
  }

  clone(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId, email } = this.props;

    this.props
      .cloneEmail(accountId, email.id, {
        name: this.nameRef?.current.value,
        campaignId: this.campaignIdRef?.current.value,
      })
      .then((data) => {
        const nextId = data.data.id;
        return this.props.gotoUrl(`/clients/${accountId}/emails/${nextId}`);
      })
      .then(this.props.closeModal);
  }

  render() {
    const { email, campaigns } = this.props;

    return (
      <Modal>
        <ModalHeader>Clone Email</ModalHeader>
        <ModalContent>
          <form onSubmit={this.clone}>
            <div className={styles.flex}>
              <label>Name</label>
              <input
                ref={this.nameRef}
                autoFocus
                defaultValue={`${email.name} copy`}
              />
            </div>
            <div className={styles.flex}>
              <label>Campaign</label>
              <select ref={this.campaignIdRef}>
                {campaigns.map((campaign, index) => {
                  return (
                    <option key={index} value={campaign.id}>
                      {campaign.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </form>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.clone}>Clone</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

CloneEmailModal.propTypes = {
  cloneEmail: PropTypes.func.isRequired,
  emailTemplatesList: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const { accountId, id } = params;
  const email = state.entities.email[id];
  const campaignsPagination = state.pagination.campaigns;
  const campaigns = (campaignsPagination.ids || [])
    .map((id) => state.entities.campaign[id])
    .filter(identity);

  return {
    accountId,
    id,
    email,
    campaigns,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  cloneEmail,
  emailTemplatesList,
  gotoUrl,
  campaignsList,
})(CloneEmailModal);
